export const DemoSectionText = {
  invite: 'Integreer aircheckr in uw services en verbeter echt de gezondheid en gebruikerservaring van uw klanten',
  cta: 'Registreer nu',
}



// WEBPACK FOOTER //
// ./src/input-text/nl/demosection.js